import { render, staticRenderFns } from "./OfficeStatus.vue?vue&type=template&id=878eaee8&"
import script from "./OfficeStatus.vue?vue&type=script&lang=js&"
export * from "./OfficeStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports